import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class AlertSettingsPageDataService {
  apiEP: string = window.apiUrl;
  constructor(private http: HttpClient) {}

  getWatchlistData(userId): Observable<any> {
    return this.http.get(
      `${this.apiEP}/watcher/get_watchers_only/?userid=${userId}`,
    );
  }

  getCompanies(keyword): Observable<any> {
    return this.http.get(`${this.apiEP}/api/n_tiksch?q=${keyword}`);
  }
  getCompanyAlerts(): Observable<any> {
    return this.http.get(
      `${this.apiEP}/app/alerts/user_alerts/?format=json&type=company`,
    );
  }
  getWatchlistAlerts(): Observable<any> {
    return this.http.get(
      `${this.apiEP}/app/alerts/user_alerts/?format=json&watchlist_alert_view=true&type=watchlist`,
    );
  }
  putEnable(params): Observable<any> {
    return this.http.put(
      `${this.apiEP}/app/alerts/user_alerts/${params.alert_id}`,
      params,
    );
  }
  deleteAlert(alertIds): Observable<any> {
    const params = { id_list: alertIds.join(",") };
    return this.http.request(
      "delete",
      `${this.apiEP}/app/alerts/user_alerts/`,
      {
        body: params,
      },
    );
  }
}
